import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { graphql } from 'gatsby';
import Layout from "../components/layout";
import Breadcrumb from '../components/breadcrumb';
import SeasonRecord from '../components/SeasonRecord';
import { seasonOutcome, gamesByOwnerFunc, scoresOwners } from '../helpers/game';

const SeasonRecords = (query) => {
		// Get GraphlQL data
		const games = query.data.allGamesJson.nodes;
		const owners = query.data.allOwnersJson.nodes;

		const [items, setItems] = useState(10);
		const [topWins, setTopWins] = useState([]);
		const [topLoses, setTopLoses] = useState([]);
		const [topScores, setTopScores] = useState([]);
		const [bottomScores, setBottomScores] = useState([]);
		const [topScoresAgaisnt, setTopScoresAgaisnt] = useState([]);
		const [bottomScoresAgaisnt, setBottomScoresAgaisnt] = useState([]);
		const [topPCT, setTopPCT] = useState([]);
		const [bottomPCT, setBottomPCT] = useState([]);
		const [topAVGPoints, setTopAVGPoints] = useState([]);
		const [bottomAVGPoints, setBottomAVGPoints] = useState([]);
		const [maxScoreWeekSeason, setMaxScoreWeekSeason] = useState([]);
		const [minScoreWeekSeason, setMinScoreWeekSeason] = useState([]);
		const [topMeanScoresWeekSeason, setTopMeanScoresWeekSeason] = useState([]);
		const [bottomMeanScoresWeekSeason, setBottomMeanScoresWeekSeason] = useState([]);

		const seasonStats = [];
		const test = [];

		useEffect(() => {
			
			// Filtramos los juegos para tener todos los juegos por owner
			const gamesByOwners = gamesByOwnerFunc(games);
			
			//Get array with just scores for each Owner
			const scoresByOwner= scoresOwners(games);

			//Order by year and week so I can get the top week score etc
			const scoresYearsWeeks = _.groupBy(scoresByOwner, (game) => {
				return [game['year'], game['week']];
			});

			// Get the max and min points in the week running the object.
			const seasonWeekStats = [];
			Object.keys(scoresYearsWeeks).forEach(key => {
				const maxScoresWeek = _.maxBy(scoresYearsWeeks[key], function(o) {
					return o.score;
				});
				const minScoresWeek = _.minBy(scoresYearsWeeks[key], function(o) {
					return o.score;
				});

				const topMeanScoresWeek = _.takeRight(_.sortBy(scoresYearsWeeks[key], ['score']), scoresYearsWeeks[key].length/2); 
				const bottomMeanScoresWeek = _.take(_.sortBy(scoresYearsWeeks[key], ['score']), scoresYearsWeeks[key].length/2); 

				seasonWeekStats.push({
					topMeanScoresWeek,
					bottomMeanScoresWeek,
					maxScoresWeek: maxScoresWeek.id,
					minScoresWeek: minScoresWeek.id,
					year: maxScoresWeek.year
				})
			});

			// Group by Year so I can get the number of times each person got each stat
			const seasonWeekYearStats = _.groupBy(seasonWeekStats, (week) => {
				return [week['year']];
			});

			//console.log(seasonWeekYearStats,"seasonWeekYearStats")

			Object.keys(seasonWeekYearStats).forEach(year => {
				const countTopMeanScore = {};
				const countBottomMeanScore = {};
				const countMaxScore = {};
				const countMinScore = {};
				// Run the object and use a map to sum how many times each owner has got the stat
				seasonWeekYearStats[year].forEach(element => {
					
					element.topMeanScoresWeek.forEach(meanScore => {
						countTopMeanScore[meanScore.id] = (countTopMeanScore[meanScore.id] || 0) + 1;
					});
					element.bottomMeanScoresWeek.forEach(meanScore => {
						countBottomMeanScore[meanScore.id] = (countBottomMeanScore[meanScore.id] || 0) + 1;
					});
					countTopMeanScore[element.maxScoresWeek] = (countMaxScore[element.maxScoresWeek] || 0) + 1;
					countMaxScore[element.maxScoresWeek] = (countMaxScore[element.maxScoresWeek] || 0) + 1;
					countMinScore[element.minScoresWeek] = (countMinScore[element.minScoresWeek] || 0) + 1;
				});

				const maxEntries = Object.entries(countMaxScore);
				maxEntries.forEach( ([ownerID, val] ) => {
					maxScoreWeekSeason.push({
						scoreOwner: ownerID,
						scoreTimes: val,
						name :_.find(owners, ['id', ownerID ]).name,
						image : _.find(owners, ['id', ownerID]).image,
						year
					})
				});

				const minEntries = Object.entries(countMinScore);
				minEntries.forEach( ([ownerID, val] ) => {
					minScoreWeekSeason.push({
						scoreOwner: ownerID,
						scoreTimes: val,
						name :_.find(owners, ['id', ownerID ]).name,
						image : _.find(owners, ['id', ownerID]).image,
						year
					})
				});

				const topMeanEntries = Object.entries(countTopMeanScore);
				topMeanEntries.forEach( ([ownerID, val] ) => {
					topMeanScoresWeekSeason.push({
						scoreOwner: ownerID,
						scoreTimes: val,
						name :_.find(owners, ['id', ownerID ]).name,
						image : _.find(owners, ['id', ownerID]).image,
						year
					})
				});

				const bottomMeanEntries = Object.entries(countBottomMeanScore);
				bottomMeanEntries.forEach( ([ownerID, val] ) => {
					bottomMeanScoresWeekSeason.push({
						scoreOwner: ownerID,
						scoreTimes: val,
						name :_.find(owners, ['id', ownerID ]).name,
						image : _.find(owners, ['id', ownerID]).image,
						year
					})
	
				});
			});

		
			gamesByOwners.forEach((owner) => {
				
				//Agrupamos los juegos por owners de cada owner por year para tener cada season
				const gamesOwnersYears = _.groupBy(owner.games, (game) => {
					return [game['year']];
				});

				//console.log(gamesOwnersYears,"gamesOwnersYears")

				//Recorremos el objecto de cada season y lo pasamos por el season outcome para obtener todos los stats de ese season
				Object.keys(gamesOwnersYears).forEach(key => {
					let season = seasonOutcome(gamesOwnersYears[key],owner.id,key,false);

					//console.log(gamesOwnersYears[key],"gamesOwnersYears[key]")
					
					season.name = _.find(owners, ['id', owner.id ]).name;
					season.image = _.find(owners, ['id', owner.id]).image;
					
					seasonStats.push(season);
				});

	
			});

			console.log(seasonStats,"seasonstats  ")
			setTopWins(() => _.orderBy(_.takeRight(_.sortBy(seasonStats, ['wins']), items), ['wins'], ['desc']));
			setTopLoses(() => _.orderBy(_.takeRight(_.sortBy(seasonStats, ['loses']), items), ['loses'], ['desc']));

			setTopPCT(() => _.orderBy(_.takeRight(_.sortBy(seasonStats, ['pct']), items), ['pct'], ['desc']));
			setBottomPCT(() => _.take(_.sortBy(seasonStats, ['pct']), items)); 

			setTopScores(() => _.orderBy(_.takeRight(_.sortBy(seasonStats, ['scoreFor']), items), ['scoreFor'], ['desc']));
			setBottomScores(() => _.take(_.sortBy(seasonStats, ['scoreFor']), items)); 

			setTopScoresAgaisnt(() => _.orderBy(_.takeRight(_.sortBy(seasonStats, ['scoreAgaisnt']), items), ['scoreAgaisnt'], ['desc']));
			setBottomScoresAgaisnt(() => _.take(_.sortBy(seasonStats, ['scoreAgaisnt']), items)); 

			setTopAVGPoints(() => _.orderBy(_.takeRight(_.sortBy(seasonStats, ['avgPoints']), items), ['avgPoints'], ['desc']));
			setBottomAVGPoints(() => _.take(_.sortBy(seasonStats, ['avgPoints']), items)); 

			setMaxScoreWeekSeason(() => _.orderBy(_.takeRight(_.sortBy(maxScoreWeekSeason, ['scoreTimes']), items), ['scoreTimes'], ['desc']));
			setMinScoreWeekSeason(() => _.orderBy(_.takeRight(_.sortBy(minScoreWeekSeason, ['scoreTimes']), items), ['scoreTimes'], ['desc']));

			setTopMeanScoresWeekSeason(() => _.orderBy(_.takeRight(_.sortBy(topMeanScoresWeekSeason, ['scoreTimes']), items), ['scoreTimes'], ['desc']));
			setBottomMeanScoresWeekSeason(() => _.orderBy(_.takeRight(_.sortBy(bottomMeanScoresWeekSeason, ['scoreTimes']), items), ['scoreTimes'], ['desc']));
	
		}, [items]);
	
		return (
				<Layout >
					<main className="container-fluid">
						<Breadcrumb title="Season Records"/>
						<div className="card mb-3">
								<div className="card-header"> 
									<label>Number of Records to show</label>
									<select className="form-control" id="itemSelector" onChange={(e) => {setItems( e.target.value)}}>
										<option value="10">10</option>
										<option value="15">15</option>
										<option value="20">20</option>
										<option value="25">25</option>			
									</select>
								</div>
								<div className="card-body">
									<div className="row">
										<SeasonRecord data={topWins} label="Wins" title="Most Wins"  />
										<SeasonRecord data={topLoses} label="Loses" title="Most Loses"  />
									</div>
									<div className="row">
										<SeasonRecord data={topPCT} label="Percentage" title="Best Percentage"  />
										<SeasonRecord data={bottomPCT} label="Percentage" title="Worst Percentage"  />
									</div>
									<div className="row my-4">
										<SeasonRecord data={topScores} label="Points" title="Most Points"  />
										<SeasonRecord data={bottomScores} label="Points" title="Less Points"  />
									</div>
									<div className="row my-4">
										<SeasonRecord data={topScoresAgaisnt} label="Points" title="Most Points Agaisnt"  />
										<SeasonRecord data={bottomScoresAgaisnt} label="Points" title="Less Points Agaisnt"  />
									</div>
									<div className="row my-4">
										<SeasonRecord data={topAVGPoints} label="Points" title="Most Points Avg/Game"  />
										<SeasonRecord data={bottomAVGPoints} label="Points" title="Less Points Avg/Game"  />
									</div>
									<div className="row my-4">
										<SeasonRecord data={maxScoreWeekSeason} label="Times" title="Most times highest score in the week"  />
										<SeasonRecord data={minScoreWeekSeason} label="Times" title="Most times lowest score in the week"  />
									</div>
									<div className="row my-4">
										<SeasonRecord data={topMeanScoresWeekSeason} label="Times" title="Most times above average score in the week"  />
										<SeasonRecord data={bottomMeanScoresWeekSeason} label="Times" title="Most times below average score in the week"  />
									</div>
								</div>
								<div className="card-footer small text-muted"></div>
							</div>
					</main>
				</Layout>
		);

}
export default SeasonRecords;

export const pageQuery = graphql`
{
  allGamesJson {
    nodes {
      id
      year
      winner
      week
      playoffTierType
      team_a {
        logo
        name
        owner
        ownerId
        rank
        score
      }
      team_b {
        logo
        name
        owner
        ownerId
        rank
        score
      } 
    }
  }
  allOwnersJson {
    nodes {
      fantasyname
      id
      image
      name
      status
    }
  }
}
`;
